import script from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=58e270aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e270aa"]])

export default __exports__